export const HERO_REQUEST = 'HERO_REQUEST'
export const HERO_SUCCESS = 'HERO_SUCCESS'
export const HERO_FAILURE = 'HERO_FAILURE'